import React, { useEffect, useState } from 'react'
import SearchFilter from '../../components/Production/Index/searchBar'
import List from '../../components/Production/Index/list'
import Layout from '../../components/common/pageLayout'
import { v2_production_stats } from '../../actions/v2/production'
const Index = () => {
  const [stats, setStats] = useState(null)
  useEffect(() => {
    v2_production_stats().then((res) => {
      if (res.status) {
        setStats(res.result.counts)
      }
    })
  }, [])
  return (
    <>
      <Layout
        title={'Production'}

      >
        {/* <SearchFilter /> */}
        <List
          stats={stats}
        />
      </Layout>

    </>
  )
}

export default Index